exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#app{text-align:center;overflow:hidden}.mark{position:fixed;left:0;top:0;opacity:.95;width:100%;height:100%;background:#000;z-index:998}.content{position:absolute;z-index:999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3be7977d","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 138
// module chunks = 1